// extracted by mini-css-extract-plugin
module.exports = {"paginationGroup":"Pagination-module--pagination-group--2gtQ-","pagination__pages":"Pagination-module--pagination__pages--DRN40","active":"Pagination-module--active--2TxZX"};